import _defineProperty from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _createForOfIteratorHelper from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
/**
 * 树转列表
 * @export
 * @param {String} childrenKey
 * @param {Array} source
 * @return {Array}
 */
export function flattenTree(childrenKey, source) {
  var result = [];
  dfs(source);
  return result;
  function dfs(items) {
    if (!items) {
      return;
    }
    var _iterator = _createForOfIteratorHelper(items),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var item = _step.value;
        result.push(item);
        if (item[childrenKey] && item[childrenKey].length > 0) {
          dfs(item[childrenKey]);
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
}

/**
 * 列表转树
 * @export
 * @param {String} idKey
 * @param {String} parentKey
 * @param {String} childrenKey
 * @param {Array} source
 * @return {Array}
 */
export function buildTree(idKey, parentKey, childrenKey, source) {
  var parentWrap = function parentWrap(nodes) {
    var parentWrapper = new Map();
    nodes.forEach(function (node) {
      if (parentWrapper.has(node[parentKey])) {
        var children = parentWrapper.get(node[parentKey]);
        if (children) {
          children.push(node);
        }
      } else {
        parentWrapper.set(node[parentKey], [node]);
      }
    });
    return parentWrapper;
  };
  var topLevelWrap = function topLevelWrap(nodes) {
    return nodes.filter(function (parent) {
      return !nodes.find(function (node) {
        return node[idKey] === parent[parentKey];
      });
    });
  };
  var build = function build(topLevel, wrapper) {
    return topLevel.map(function (node) {
      if (wrapper.has(node[idKey])) {
        var children = build(wrapper.get(node[idKey]), wrapper);
        return _objectSpread(_objectSpread({}, node), {}, _defineProperty({}, childrenKey, children));
      } else {
        return node;
      }
    });
  };
  var topLevelWrapper = topLevelWrap(source);
  var parentWrapper = parentWrap(source);
  return build(topLevelWrapper, parentWrapper);
}